/**
 * Created by lihanying on 2017/6/29.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { postData, fetchData } from '../../util/index'
import { GETCLUBREVENUENEW, GETPERIOD } from './constants'
import { col_revenue } from '../../components/CommonTable/columns'
import { round } from '../../util/index'

export const getClubRevenue = (payload) => {
  return {
    type: GETCLUBREVENUENEW,
    payload,
  }
}

export const getPeriod = (payload) => {
  return {
    type: GETPERIOD,
    payload,
  }
}

//新营收报表
export function fetchClubRevenue(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/BusinessApi/StatisticPeriod`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((res) => {
      if (!res) return dispatch(getClubRevenue([]))
      const data =
        res && res['data']
          ? res['data'][0]
            ? res['data'][0].statistics
            : []
          : []
      if (data && Array.isArray(data) && data.length > 0) {
        const newData = data.map((item) => {
          for (let i in col_revenue) {
            const index = col_revenue[i].dataIndex
            switch (index) {
              case 'startTime':
                item[index] = item['startTime'].slice(0, 10)
                break
              case 'ratioIncomeThirdParty':
                item[index] = round(+item['ratioIncomeThirdParty'] * 100, 2)
                break
              case 'feeMemberRewards':
                item[index] = round(+item['feeMemberReward'] / 100, 2)
                break
              case 'incomeSummary':
                item[index] = round(+item['incomeSummary'] / 100, 2)
                break
              default:
                item[index] = round(+item[index] / 100, 2)
            }
          }
          return item
        })
        dispatch(getClubRevenue(newData))
      } else {
        dispatch(getClubRevenue([]))
      }
      return res
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubRevenueNew/action.js